export default __webpack_public_path__ + "static/media/admission.3fb0ca75.png";